import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PHONE_TOUCH_SIZE } from '@natter-co/design-system';
import { IconButton } from 'common/components/Buttons/IconButton';
import { Tooltip } from 'common/components/Tooltip';
import { useCopyToClipboard } from 'common/hooks/useCopyToClipboard';
import { useTimeout } from 'common/hooks/useTimeout';
import { CopyIcon } from 'icons';

const COPY_TOOLTIP_TIMEOUT = 1_000;

type CopyButtonProps = {
  value: string;
};

export const CopyButton = ({ value }: CopyButtonProps) => {
  const [tooltipText, setTooltipText] = useState('');
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('common', { keyPrefix: 'clipboard' });

  const { reset } = useTimeout(() => {
    setOpen(false);
  }, COPY_TOOLTIP_TIMEOUT);

  const { copyToClipboard } = useCopyToClipboard({
    onSuccess: () => {
      setTooltipText(t('copiedToClipboard'));
      setOpen(true);
      reset();
    },
    onError: () => {
      setTooltipText(t('copyToClipboardFailed'));
      setOpen(true);
      reset();
    },
  });

  const handleCopy = () => {
    copyToClipboard({ text: value });
  };

  return (
    <Tooltip title={tooltipText} open={open} placement="top">
      <IconButton variant="text" onClick={handleCopy} sx={{ minWidth: PHONE_TOUCH_SIZE, minHeight: PHONE_TOUCH_SIZE }}>
        <CopyIcon />
      </IconButton>
    </Tooltip>
  );
};
